import { useState, useRef, useEffect } from "react";
import { ListItem, List } from "../components/Common";
import { useNavigate } from "react-router-dom";
import { Text } from "../UI";
import { useTheme } from "styled-components";

export const BottomDrawer = ({ items, show, setShow, ...props }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const [height, setHeight] = useState(items.length * 45 + 100); // initial height in px
  const isDragging = useRef(false);
  const drawerRef = useRef();
  const startY = useRef(0);
  const startHeight = useRef(0);

  // Start dragging when mouse is pressed down on the handle
  const startDragging = (e) => {
    isDragging.current = true;
    startY.current = e.touches[0].clientY;
    startHeight.current = height;
    document.addEventListener("touchmove", handleDragging, { passive: false }); // Listen for mousemove
    document.addEventListener("touchend", stopDragging); // Listen for mouseup
  };

  // Handle the dragging event
  const handleDragging = (e) => {
    if (!isDragging.current) return;
  
    if (!e.touches || !e.touches[0]) return;
  
    e.preventDefault(); // <-- Prevent scrolling
  
    const deltaY = e.touches[0].clientY - startY.current;
    const newHeight = startHeight.current - deltaY;
  
    if (newHeight < 230) {
      setShow(false);
    } else {
      setHeight(newHeight);
    }
  };

  // Stop dragging when the mouse button is released
  const stopDragging = () => {
    isDragging.current = false;
    document.removeEventListener("touchmove", handleDragging);
    document.removeEventListener("touchend", stopDragging);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawerRef]);

  return (
    <div
      ref={drawerRef}
      style={{
        width: "100vw",
        borderRadius: "18px 18px 0 0",
        position: "absolute",
        bottom: 0,
        backgroundColor: theme.color.white,
        boxShadow: `0px 4px 20px #C3C0D3`,
        padding: "30px 40px",
        zIndex: 9999,
        height: height,
        transition: "height 0.2s",
      }}
    >
      <div
        onTouchStart={startDragging}
        style={{
          width: 40,
          margin: "auto",
          marginBottom: 20,
          borderRadius: 2,
          cursor: "ns-resize",
          borderTop: "2px solid #EAEEF4",
        }}
      />
      <div>
        <List style={{ flexDirection: "column", gap: 5 }}>
          {items.map((department, index) => (
            <ListItem
              key={index}
              onClick={() => {
                if (department.BEDEKFLAG === "Y") {
                  if (props.bedek) {
                    navigate("/bedek/new-repair-page", {
                      state: {
                        department: department.DEPARTDES,
                        bedek: true,
                      },
                    });
                  } else {
                    navigate("/tenant/new-repair-page", {
                      state: {
                        department: department.DEPARTDES,
                        user: department.USERLOGIN,
                      },
                    });
                  }
                } else {
                  navigate("/tenant/new-apply", {
                    state: {
                      department: department.DEPARTDES,
                      user: department.USERLOGIN,
                      type: department.CUSTNOTETYPEDES,
                    },
                  });
                }

                setShow(!show);
              }}
              style={{
                width: "auto",
                height: "auto",
                cursor: "pointer",
              }}
            >
              <Text.BB
                key={index}
                color={theme.color.gray90}
                style={{ cursor: "pointer" }}
              >
                {department.DEPARTDES}
              </Text.BB>
            </ListItem>
          ))}
        </List>
      </div>
    </div>
  );
};
